import type { escritas as pt } from '../pt-BR/escritas';
import type { Traducao } from '../Traducao';

export const escritas = {
  titulo: 'Grabación en el registro (Axiis)',
  camiseta: 'Camiseta',
  endereco: 'Dirección oficial',
  incompleto: 'Guardado sin ciudad o estado',
  status: {
    pendente: 'Pendientes: {{n}}',
    sucesso: 'Grabadas: {{n}}',
    falha: 'Con error: {{n}}',
  },
  retentar: 'Intentar grabar de nuevo',
  confirmarRetentar:
    '¿Intentar de nuevo la grabación en Axiis de los elementos pendientes y con error? Los valores son los de la última respuesta de cada persona.',
  resultado_zero: '{{count}} grabados, {{falha}} con error.',
  resultado_one: '{{count}} grabado, {{falha}} con error.',
  resultado_other: '{{count}} grabados, {{falha}} con error.',
} as const satisfies Traducao<typeof pt>;
